export default __webpack_public_path__ + "static/performanceSection4_img2-21f85eb8eaa103e40f85fb073dd4e4a3.png";